import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { ChevronIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import ItemHeading from './ItemHeading';
import ItemContent from './ItemContent';
import {
  ItemContainer,
  ButtonLinkStyled as ButtonLink,
} from './styles/ItemStyled';
import { GoogleTagManager } from '../../../../helpers';

const goToSmsPrem = () => {
  GoogleTagManager.tagInteractiveEvent({
    eventCategory: 'SMS Premium',
    eventAction: 'Presionar Botón - Gestionar Mensajeria',
    eventTag: 'SMS Premium - Mis boletas',
  });
  navigate('/marketplace/carrier-billing/mensajeria-premium');
};

const Item = ({ data }) => {
  const isDiscount = /Descuentos/i.test(data.name);
  const hasSmsPremium = data.subcategories.some(({ name }) =>
    /Mensajer[ií]a Premium/i.test(name)
  );

  const itemData = {
    name: data.name,
    amount: isDiscount ? Math.abs(data.amount) * -1 : data.amount,
  };
  const subcategories = isDiscount
    ? data.subcategories.map(val => ({
        ...val,
        amount: Math.abs(val.amount) * -1,
      }))
    : data.subcategories;
  return (
    <ItemContainer>
      <ItemHeading data={itemData} />
      <ItemContent data={subcategories} />
      {hasSmsPremium && (
        <ButtonLink onClick={goToSmsPrem}>
          Gestionar otras suscripciones
          <ChevronIcon />
        </ButtonLink>
      )}
    </ItemContainer>
  );
};

Item.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default Item;
